import { useQuery } from "@tanstack/react-query";
import { sharedApi } from "@/lib/api";

/**
 * Iter-333/334/335 — points endpoints (verified live on preview backend):
 *   GET /api/points/balance (auth) → { balance, monetary_value_nzd,
 *     redeem_rate_per_nzd, bazaar_balance, nz_classified_balance }
 *   GET /api/points/terms (public) → { version, rates, earn[], use[], terms[] }
 */

export function usePointsBalance(enabled = true) {
  return useQuery({
    queryKey: ["points-balance"],
    enabled,
    retry: 0,
    staleTime: 15_000,
    queryFn: async () => (await sharedApi.get("/points/balance")).data,
  });
}

export function usePointsTerms() {
  return useQuery({
    queryKey: ["points-terms"],
    retry: 1,
    staleTime: 5 * 60_000,
    queryFn: async () => (await sharedApi.get("/points/terms")).data,
  });
}
